export const BASE_URL = 'https://vj.inmapz.com';
// export const BASE_URL = 'http://vietjet.inmapz.local:8080';
export const API_PATH = '/api';

//Google Geocoding
export const GEOCODING_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
export const GOOGLE_API_KEY = 'AIzaSyDL41qTlES_0RQUqItpAXD1ufP53hqT1sk';

//Google map token
export const GOOGLE_MAP_TOKEN = 'AIzaSyAdiD2jDb9DQhdAEWgJvSMnKO78E3oHhVY';

//API
export const GET_AIPORT_ITEMS = API_PATH + '/airports';
export const GET_REGIONS = API_PATH + '/regions';
export const GET_All_ROUTES = API_PATH + '/itineraries';
export const GET_ITINERARIES = API_PATH + '/route';
export const GET_ITINERARIES_NETWORK = API_PATH + '/itineraries-network';
export const GET_FLIGHT_NETWORK = API_PATH + '/flight-network';
export const GET_ROUTE_PRICE = API_PATH + '/flight-fare';


export const BOOKING = `https://uat.vietjet.io/?currency=VND&languageCode={lang}&departAirport={origin}&arrivalAirport={destination}&departDate={date}&tripType=oneway&adultCount=1&childCount=0&infantCount=0&gclid=ADowPOLOVeOWBTssFvH3wBcRtam8VSdIOcVlXonLJVTN4C4esWeA35scL4yfFSD---yDCj_tDnu9HYhq8yp97iSvOtpY2qaQLQdkJpJX7EbQPn6S9X3Y&gclsrc=gf`;
export const SCHEDULE = `https://www.vietjetair.com/{lang}`;
export const BRANCHES = `https://www.vietjetair.com/{lang}`;
export const AIRPORT_MAP_URL = ``;
